import { render, staticRenderFns } from "./_hotClass.vue?vue&type=template&id=b6271396&scoped=true"
import script from "./_hotClass.vue?vue&type=script&lang=js"
export * from "./_hotClass.vue?vue&type=script&lang=js"
import style0 from "./_hotClass.vue?vue&type=style&index=0&id=b6271396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6271396",
  null
  
)

export default component.exports